import { useCtx } from '@reatom/npm-react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { createGetContext } from './context';
export function useCallbackRef$(callback$) {
    const ctx = useCtx();
    return useCallbackRef(callback$(createGetContext(ctx)));
}
